/** Sentinel Analytics pages, as kim-ai-frontend laid them out. */
export const SENTINEL_ANALYTICS_PATHS = {
  SUPPORT_OVERVIEW: '/analytics/sentinel/support/overview',
  SUPPORT_PERFORMANCE: '/analytics/sentinel/support/performance',
  INFLOW_OVERVIEW: '/analytics/sentinel/inflow/overview',
  INFLOW_MESSAGE_METRICS: '/analytics/sentinel/inflow/message-metrics',
  INFLOW_TICKET_METRICS: '/analytics/sentinel/inflow/ticket-metrics',
} as const;
